import { Pipe, PipeTransform } from '@angular/core';
import { QuoteItemInfo } from '../models/models';

@Pipe({
  name: 'findQuoteItem'
})
export class FindQuoteItemPipe implements PipeTransform {
  transform(items: QuoteItemInfo[], quoteItemId: number): QuoteItemInfo | undefined {
    return items.find(i => i.quote_item.id === quoteItemId);
  }
}
